export default "__VITE_ASSET__DDw1cFKA__"